"use client"

import { Card, CardContent, CardHeader, Grid, Button, Typography } from "@mui/material"
import { Event, People, Inventory, Receipt, Assessment } from "@mui/icons-material"

const QuickActions = () => {
  const quickActions = [
    { icon: People, label: "New Customer", action: () => console.log("Add Customer") },
    { icon: Inventory, label: "Add Product", action: () => console.log("Add Product") },
    { icon: Receipt, label: "Create Invoice", action: () => console.log("Create Invoice") },
    { icon: Assessment, label: "View Reports", action: () => console.log("View Reports") },
  ]

  return (
    <Card>
      <CardHeader
        avatar={<Event color="primary" />}
        title="Quick Actions"
        subheader="Quickly complete necessary tasks"
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          {quickActions.map((action, index) => {
            const Icon = action.icon
            return (
              <Grid item xs={6} key={index}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={action.action}
                  sx={{
                    height: 80,
                    flexDirection: "column",
                    gap: 1,
                    "&:hover": {
                      bgcolor: "primary.50",
                    },
                  }}
                >
                  <Icon />
                  <Typography variant="caption">{action.label}</Typography>
                </Button>
              </Grid>
            )
          })}
        </Grid>
      </CardContent>
    </Card>
  )
}

export default QuickActions
